module.exports = __webpack_public_path__ + "static/result_namyangju-d0a97c271b4306c7fb8748f58be8a3a1.png";